(function() {
    // Matches email-addresses
    // Either using a domain or an IP address
    // Possible bugs:
    // - Immediately after the @ symbol an opening square bracket is required in the IP group -> <front part>@[<IP ADDRESS>]

    angular.module("app").constant("EMAIL_REGEXP", /^(([^<>()\/[\]\\.,;:'$%&\s@"]+(\.[^<>()\/[\]\\.,;:'$%&\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
})();